import React, { useEffect, useMemo } from 'react';
import { TreeSelect } from 'antd';
import { FormikProps } from 'formik';
import { useSelector } from 'react-redux';

import { useLazyReadCategoriesQuery } from '../service/categories';
import { getCategoryState } from '../store/categorySlice';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

type Props = {
    width?: number;
    formik?: FormikProps<{ category_ids: number[] }>;
    type?: string;
    isDisabled: boolean;
};
export const ProductCategoriesSelector = ({
    formik,
    isDisabled,
    type,
    width,
}: Props) => {
    const current = useAppSelector(selectShopCurrent);
    const { nestedCategoryList } = useSelector(getCategoryState);

    const [getCategories] = useLazyReadCategoriesQuery();

    useEffect(() => {
        if (current.id) {
            getCategories({ shop_id: current.id }, true);
        }
    }, [current.id]);

    const onChange = newValue => {
        let newValuesToSave = [];
        if (newValue?.length === 0) {
            newValuesToSave = [0];
        } else if (newValue?.length >= 2) {
            newValuesToSave = newValue.filter(function (num) {
                return num !== 0;
            });
        } else {
            newValuesToSave = newValue;
        }

        formik.setFieldValue('category_ids', newValuesToSave);
    };

    const dropdownItems = useMemo(() => {
        return nestedCategoryList.filter(category => category.id !== null);
    }, [nestedCategoryList, type]);

    return (
        <TreeSelect
            maxTagCount={'responsive'}
            placeholder={'Выберите категорию'}
            bordered={true}
            treeCheckable={false}
            showSearch={true}
            style={{ width: width || 300 }}
            showCheckedStrategy={TreeSelect.SHOW_CHILD}
            treeData={dropdownItems}
            filterTreeNode={(search, item) => {
                return (
                    item.name.toLowerCase().indexOf(search.toLowerCase()) >= 0
                );
            }}
            fieldNames={{
                label: 'name',
                value: 'id',
                children: 'childCategoryList',
            }}
            multiple
            onChange={onChange}
            defaultValue={[0]}
            value={formik.values.category_ids}
            disabled={isDisabled}
        />
    );
};
